export default __webpack_public_path__ + "218067fa87ef575f4b7cf07f639eb460.png";